import { render, staticRenderFns } from "./ProjectLifeCycle.vue?vue&type=template&id=38e1d1b6&scoped=true&"
import script from "./ProjectLifeCycle.vue?vue&type=script&lang=js&"
export * from "./ProjectLifeCycle.vue?vue&type=script&lang=js&"
import style0 from "./ProjectLifeCycle.vue?vue&type=style&index=0&id=38e1d1b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e1d1b6",
  null
  
)

export default component.exports